import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { light, dark } from './Theme';
import { Routes, Route, useLocation } from 'react-router-dom';
import PurchasesPage from './Pages/Purchases';
import LandingPage from './Pages/Landing';
import CreditsPage from './Pages/Credits';
import NotificationPage from './Pages/Notification';
import ProfilePage from './Pages/Profile';
import LoginPage from './Pages/Login';
import HomePage from './Pages/Home';
import BranchesPage from './Pages/Branches';
import BranchDetailPage from './Pages/BranchDetail';
import EditProfilePage from './Pages/Profile/EditProfilePage';
import FacturePage from './Pages/Facture';
import CreditDetailsPage from './Pages/CreditDetails';
import { useNavigate } from 'react-router';
import useLandingStore from './Store/Landing';
import { logoutAction } from './Utils/common.util';
import NotFound from './Pages/NotFound';
import ContactUsPage from './Pages/ContactUs';
import * as Sentry from '@sentry/react';
import SubCreditPage from './Pages/SubCredit';
import CreditHistoryPage from './Pages/CreditHistory';

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const smsUrl = useLandingStore((state) => state.smsUrl);
  const isThereToken = useLandingStore((state) => state.isThereToken);
  const setIsThereToken = useLandingStore((state) => state.setIsThereToken);

  useEffect(() => {
    !localStorage.getItem('access_token') &&
      !location.pathname.includes('/p/') &&
      !location.pathname.includes('branches') &&
      !location.pathname.includes('/e/') &&
      location.pathname !== '/login' &&
      navigate(smsUrl);

    location.pathname === '/login' &&
      localStorage.getItem('access_token') &&
      navigate('/credits');
  }, [location]);

  useEffect(() => {
    !isThereToken && logoutAction(navigate, smsUrl);
    setIsThereToken(true);
  }, [isThereToken]);

  return (
    <ThemeProvider theme={light}>
      <Routes>
        <Route path="/e/:smsId/:customerGuid" element={<LandingPage />} />
        <Route path="/p/:smartGuid" element={<LandingPage />} />
        <Route path="/p/:smartGuid/:customerGuid" element={<LandingPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/creditsHistory" element={<CreditHistoryPage />} />
        <Route path="/subCredits" element={<SubCreditPage />} />
        <Route
          path="/credit/:customerActivityId"
          element={<CreditDetailsPage />}
        />
        <Route path="/contactUs" element={<ContactUsPage />} />
        <Route path="/purchases" element={<PurchasesPage />} />
        <Route path="/facture/:factureId" element={<FacturePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/branches" element={<BranchesPage />} />
        {/*<Route path="/branches/:branchId" element={<BranchDetailPage />} />*/}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/edit" element={<EditProfilePage />} />
        <Route path="/notifications" element={<NotificationPage />} />
        {/*<Route path="/home" element={<HomePage />} />*/}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
};

export default Sentry.withProfiler(App);
